import React from 'react';
import classNames from 'classnames';
import ToggleContainer from '../../Containers/toggleContainer';
import ExpandableButton from '../../Buttons';

const VisitDropdown = ({ ButtonText, ButtonId, Content }) => {
  return (
    <ToggleContainer open={false}>
      {({ open, toggle }) => (
        <div
          className={classNames({
            'your-visit__dropdown': true,
            'your-visit__dropdown--is-open': open,
          })}
        >
          <h3>
            <ExpandableButton
              onClick={toggle}
              open={open}
              buttonClass="your-visit__toggle-button"
              iconClass="plus--extended-info"
              buttonText={ButtonText}
              buttonId={ButtonId}
              textClass="your-visit__toggle-button__text"
            />
          </h3>
          <div
            className={classNames({
              'your-visit__content': true,
              visible: open,
            })}
            dangerouslySetInnerHTML={{ __html: Content }}
          ></div>
        </div>
      )}
    </ToggleContainer>
  );
};

const YourVisit = (props) => {
  const { Translations, YourVisit } = props;
  return (
    <div className="your-visit">
      <div
        className="your-visit__preamble"
        dangerouslySetInnerHTML={{ __html: YourVisit.Preamble }}
      />
      {YourVisit.BeforeVisit && (
        <VisitDropdown
          ButtonText={Translations.beforevisit}
          ButtonId="beforevisit"
          Content={YourVisit.BeforeVisit.Text}
        />
      )}
      {YourVisit.DuringVisit && (
        <VisitDropdown
          ButtonText={Translations.duringvisit}
          ButtonId="duringvisit"
          Content={YourVisit.DuringVisit.Text}
        />
      )}
      {YourVisit.AfterVisit && (
        <VisitDropdown
          ButtonText={Translations.aftervisit}
          ButtonId="aftervisit"
          Content={YourVisit.AfterVisit.Text}
        />
      )}
    </div>
  );
};

export default YourVisit;
